import { IUserPersonalData } from '@store/userStore/userStore.type';
import { defaultUserPersonalData } from '@store/userStore/userStore.variables';
import { useQuery } from '@tanstack/react-query';
import { userKeys } from '../queriesKeys';

const useUserPersonalData = <TReturnType = IUserPersonalData>(
	select?: (data: IUserPersonalData) => TReturnType
): TReturnType => {
	const { data = defaultUserPersonalData } = useQuery({
		queryKey: userKeys.all,
		placeholderData: defaultUserPersonalData,
		enabled: false,
		select
	});

	return data as TReturnType;
};

export { useUserPersonalData };
